import React from "react";
import { Box, Checkbox, Radio, TextField, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface MyTaxCreditApplicationCheckboxLineProps {
  id: string;
  prefix?: React.ReactNode;
  checked: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  text: string;
  type?: "checkbox" | "radio";
  textInput?: boolean;
  textInputType?: string;
  checkboxDisabled?: boolean;
  value?: string;
  label?: string;
  textInputDisabled?: boolean;
  radioDisabled?: boolean;
  onChangeInput?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  textInputBeforeText?: string;
  isMobile?: boolean;
  editable?: boolean;
}

export const MyTaxCreditApplicationCheckboxLine: React.FC<
  MyTaxCreditApplicationCheckboxLineProps
> = ({
  id,
  prefix,
  checked,
  onChange,
  text,
  type,
  textInput,
  textInputType,
  checkboxDisabled,
  value,
  label,
  textInputDisabled,
  radioDisabled,
  onChangeInput,
  textInputBeforeText,
  isMobile,
  editable,
}) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      alignItems={isMobile ? "flex-start" : "center"}
      style={{
        color:
          radioDisabled || textInputDisabled || checkboxDisabled
            ? theme.palette.gray60.main
            : theme.palette.darkBase.main,
      }}
    >
      {prefix}
      <Box width="7px" />
      {type === "checkbox" && (
        <Checkbox
          id={`${id}-checkbox`}
          name={`${id}-checkbox`}
          checked={checked}
          onChange={onChange}
          style={{
            color: checkboxDisabled
              ? theme.palette.gray60.main
              : theme.palette.darkBase.main,
          }}
          disabled={checkboxDisabled}
        />
      )}
      {type === "radio" && (
        <Radio
          disabled={radioDisabled}
          checked={checked}
          onChange={onChange}
          id={`${id}-radio`}
          name={`${id}-radio`}
          style={{
            color: radioDisabled
              ? theme.palette.gray60.main
              : theme.palette.darkBase.main,
          }}
        />
      )}
      {textInput && (
        <Box display="flex" alignItems="center">
          {textInputBeforeText && textInputBeforeText.length > 0 && (
            <>
              <Box marginLeft="7px" />
              <Typography variant="body1" color={editable ? "primary" : "info"}>
                {textInputBeforeText}
              </Typography>
              <Box marginLeft="11px" />
            </>
          )}
          <Box
            width="200px"
            marginLeft={isMobile ? "0px" : "7px"}
            marginRight="16px"
            style={{
              backgroundColor: "white",
              borderRadius: "4px",
            }}
          >
            <TextField
              id={`${id}-input`}
              name={`${id}-input`}
              disabled={textInputDisabled}
              value={value}
              variant="outlined"
              fullWidth
              label={label}
              type={textInputType}
              onChange={onChangeInput}
              InputProps={{
                inputProps: {
                  min: "0",
                },
              }}
            />
          </Box>
        </Box>
      )}
      <Box width="7px" />
      <Typography
        variant="body1"
        color={
          editable && !checkboxDisabled && !textInputDisabled
            ? "primary"
            : "info"
        }
      >
        {text}
      </Typography>
    </Box>
  );
};

export default MyTaxCreditApplicationCheckboxLine;
